import { render } from "./DirectoryBasePage.vue?vue&type=template&id=a33750ea&ts=true"
import script from "./DirectoryBasePage.vue?vue&type=script&lang=ts"
export * from "./DirectoryBasePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__